/**
 * Who gets into Members Apps (/apps).
 *
 * The rest of the site lets every Skool member in. Apps are the step up: paid site plans
 * (monthly, yearly, lifetime, admin grants) and Skool Premium or VIP only. skool-sync stores
 * the Skool tier as plan_name "Skool <Tier>"; no tier is "Skool Member".
 *
 * ponytail: client-side check only. Each app that spends money (LLM calls) must repeat this
 * rule server-side in its edge function before it goes live.
 */
export const canUseApps = (hasAccess: boolean, planName: string | null): boolean => {
  if (!hasAccess) return false;
  const plan = (planName ?? "").trim().toLowerCase();
  if (!plan.startsWith("skool")) return true; // a site plan or an admin grant
  return plan === "skool premium" || plan === "skool vip";
};
